<template>
  <div>
     <el-tabs>
      <el-tab-pane
        v-for="(risk, riskLevel) in workflow.risks"
        v-bind:key="riskLevel"
        :label="`${$t('Riesgos Nivel')} ${risk[0].riskLevel}`">
        <br>
        <el-steps :space="200" :active="risk.length">
          <el-step
            v-for="(step, step_index) in risk"
            v-bind:key="step_index">
            <div slot="title">{{$t('Paso')}} {{ step_index + 1 }}</div>
            <div
              slot="description"
              v-for="(profile, index) in step.peopleProfile"
              v-bind:key="index"
              >
              {{ bhpProfiles[profile] }}<br>
            </div>
            <div slot="description">
              <el-tooltip
                :content="$t('Cantidad de aprobaciones necesarias para continuar')"
                placement="right">
                  <b>[{{ step.minToApprove }}/{{ step.totalPeople }}]</b>
              </el-tooltip>
            </div>
          </el-step>
        </el-steps>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'workflow2',
  props: ['workflow', 'params'],
  data() {
    return {
      bhpProfiles: {
        hse: 'HSE',
        health: this.$t('Especialista de Salud'),
        safety: this.$t('Especialista de Seguridad'),
        environment: this.$t('Especialista de Medioambiente'),
        contractor_hse: this.$t('HSE Contratista'),
        owner: this.$t('Dueño de Contrato'),
        contract_owner: this.$t('Dueño de Contrato'),
        risk: this.$t('Especialista de Riesgo'),
        administrator: this.$t('Administrador de Contrato'),
        contractor_coordinator: this.$t('Coordinador Contratista'),
        coordinator: this.$t('Coordinador'),
        manager: this.$t('Gerente'),
        super: this.$t('Superintendente'),
        general_manager: this.$t('Gerente General'),
      },
    };
  },
};
</script>


<style scoped>
  .el-card {
    border: 2px solid #f89559;
  }
  .el-card__header {
    padding: 18px 20px;
    border-bottom: 1px solid #f89559;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
</style>
